import Button from './Buttons/Button';
import ScrollWrapper from './ScrollWrapper';

const Form = ({children, onSubmitAction = null, submitButtonText = null, size = "w-full h-full", background= "bg-white", border = ""}) =>{

    const MainView = () =>(
        <form onSubmit={onSubmitAction} className={`${size} flex flex-col ${background} ${border}`}>
            <ScrollWrapper>
                <div className={`${size} flex flex-col gap-2 p-4 ${background} ${border}`}>
                {children}
                </div>
            </ScrollWrapper>
            
            <div className="w-full flex py-2">
                <Button type='submit' buttonColor='bg-orange-300' classNames='w-full hover:bg-orange-700 text-white px-2 py-2' text={submitButtonText} />
            </div>
        </form>
    )
    return MainView()
}

export default Form 